SupportBasePopupViewTemplate = require('../../base_popup_view.html.mustache')
Backbone = require 'backbone'
Backbone.$ = $

class SupportbasePopupView extends Backbone.View
  initialize: (options)->
    @I18nScope = 'modules.support'
    @template = SupportBasePopupViewTemplate
    _.bindAll.apply(_, [this].concat(_.functions(this)))
    @popup = $("#popup")
    @popupView = options.popupView

  renderHeaderAndFooter: ->
    toHtml @template, {}, @I18nScope

  render: ->
    GIG.Modal.open
      el: @popup
      closeOnBgClick: true
      closeOnEscKey: true
    @$el.html @renderHeaderAndFooter()
    @popup.html(this.el)
    @popupView.render()
    addEl = $(@el).find('.itemsPopupData')
    addEl.append(@popupView.el)
    @delegateEvents()

  closeModal: ->
    GIG.Modal.close()
    return false

  events :
    'click .close-modal' : "closeModal"

module.exports = SupportbasePopupView
